import actionTypes from '../../action-types'

export default (payload) => ({
  type: actionTypes.IMPORTERS.FETCH_LOCATIONS,
  payload,
})
